<template>
  <div>
    <v-toolbar color="#FEF3C8" class="elevation-0" dense>
      <v-btn icon color="#bd595d" @click="prev">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-chip @click="setToday" text-color="#bd595d" color="#FDE0A2" class="mr-1"> aujourd'hui
      </v-chip>

      <v-chip @click="ChangPeriode" text-color="#bd595d" color="#FDE0A2">
        <v-icon>mdi-eye-outline</v-icon> {{ periode }}
      </v-chip>
      <v-spacer></v-spacer>
      <span class="toolbar-title">{{ currentMonth }}</span>
      <v-spacer></v-spacer>
      <v-btn icon color="#bd595d" @click="next">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-toolbar>

<div v-for="item in TC" :key="item"><h2>{{ TCnom[item] }}</h2>
<v-row>
      <v-col>
        <v-sheet>
          <v-calendar ref="calendar" v-model="focus" :now="today" :value="today" :events="events[item]" :type="type"
            weekdays="1,2,3,4,5,6" locale="fr" short-weekdays="false" first-interval="5" interval-minutes="60"
            interval-count="19" interval-height="30" @change="getEvents" color="#bd595d" :event-color="getEventColor"
            :event-text-color="getEventTextColor" @click:event="showEvent" @click:time="ChooseTime"></v-calendar>
        </v-sheet>
      </v-col>
    </v-row>

     </div>

         <v-row style="display:none">
          <v-col>
        <v-sheet>
          <v-calendar ref="calendar" v-model="focus" :now="today" :value="today" :events="events[0]" :type="type"
            weekdays="1,2,3,4,5,6" locale="fr" short-weekdays="false" first-interval="5" interval-minutes="60"
            interval-count="19" interval-height="30" @change="getEvents" color="#bd595d" :event-color="getEventColor"
            :event-text-color="getEventTextColor" @click:event="showEvent" @click:time="ChooseTime"></v-calendar>
        </v-sheet>
      </v-col>
    </v-row>

    <!--################    MODALE RDV  ################################### -->
    <v-dialog v-model="showModalRDV" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="#FEF3C8">
          <v-btn icon dark @click="showModalRDV = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <h2>{{ current_client_name }}</h2>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-form ref="form" v-model="valid" lazy-validation>

          <v-select v-model="Pres_nat" :items="prests" item-text="Pre_Nom" item-value="Pre_ID"></v-select>
          <v-row>
            <v-col cols="12">
              {{ datedisplay }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">

            </v-col>
            <v-col cols="3">
              <v-text-field v-model="hdeb" label="début" :value="hdeb" type="time"></v-text-field>
            </v-col>
            <v-col cols="2">

            </v-col>
            <v-col cols="3">
              <v-text-field v-model="hfin" label="fin" :value="hfin" type="time"></v-text-field>
            </v-col>
            <v-col cols="2">

            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">

            </v-col>
            <v-col cols="4">
              <v-text-field v-model="Pres_TpsInter" label="temps réel" v-if="Pres_nat==13"></v-text-field>
            </v-col>
            <v-col cols="4">

            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn color="success" class="mr-4" @click="validateEnr">
                Enregistrer
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn color="danger" class="mr-4" @click="deleteEnr">
                Effacer
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>

    <!-----------------------------------------------   --------->
  </div>
</template>

<script>
import {
  minuAPI
} from '../services/http-common'
import {
  Plugins
} from '@capacitor/core'
import * as fb from '../firebase'
import Swal from 'sweetalert2'
const {
  Storage
} = Plugins
export default {
  name: 'Alltcs',
  data: () => ({
    focus: '',
    events: [],
    poses: [],
    prests: [],
    type: 'week',
    periode: '  voir à la journée',
    timeChoice: '',
    showModalRDV: false,
    Pres_nat: 0,
    hdeb: '12:00:00',
    hfin: '14:00:00',
    datedisplay: '',
    addrdv: false,
    start: {},
    end: {},
    current_id: 0,
    current_client: 2,
    current_client_name: '',
    FabEnabled: false,
    Pres_TpsInter: 0,
    TC: [],
    TCnom: []

  }),

  methods: {
    async getContact () {
      const ret = await Storage.get({
        key: 'contact'
      })
      console.log(ret)
      if (ret.value != null) {
        const jso = JSON.parse(ret.value)

        console.log(jso)
        this.current_client = jso.id
        this.current_client_name = jso.nom
      }
    },
    addRDV () {
      this.showModalRDV = true
      this.addrdv = true
      Storage.remove({
        key: 'contact'
      })
      minuAPI.post('prests.php', {
        'email': fb.auth.currentUser.email,
        'Pres_cl': this.current_client
      })
        .then(response => {
          this.prests = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    ChangPeriode () {
      this.type = (this.type === 'week') ? 'day' : 'week'
      this.periode = (this.type === 'week') ? 'journée' : 'semaine'
    },
    ChooseTime (tms) {
      console.log(tms)
      this.timeChoice = tms.date + ' ' + tms.hour + ':00:00'
      console.log(this.timeChoice)
      this.hdeb = tms.hour + ':00:00'
      this.hfin = (tms.hour + 2) + ':00:00'
      this.datedisplay = tms.day.toString().padStart(2, '0') + '/' + tms.month.toString().padStart(2, '0') + '/' + tms
        .year
      this.getContact()
      this.FabEnabled = true
    },
    prev () {
      this.$refs.calendar[0].prev()
    },
    next () {
      this.$refs.calendar[0].next()
    },

    setToday () {
      this.focus = ''
    },
    getEventColor (event) {
      return event.color
    },

    getEventTextColor (event) {
      return event.textcolor
    },

    SelectedCont (contact) {
      Swal.fire({
        title: contact.Cont_Societ,
        html: contact.html
      })
    },

    showEvent ({
      nativeEvent,
      event
    }) {
      console.log('id : ' + event.id)
      // this.current_client_name = event.nom
      this.addrdv = false
      Swal.fire({
        title: event.nom,
        html: event.detail,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        // confirmButtonText: 'Gérer',
        cancelButtonText: 'Fermer'
      }).then((result) => {
        // if (result.isConfirmed) {
        //   this.showModalRDV = true
        //   console.log(event)

        //   minuAPI.post('prests.php', {
        //     'email': fb.auth.currentUser.email,
        //     'Pres_cl': event.Pres_cl
        //   })
        //     .then(response => {
        //       this.prests = response.data
        //       // console.log(response.data) // properties

        //       this.hdeb = event.hdeb
        //       this.hfin = event.hfin
        //       this.datedisplay = event.datedisplay
        //       this.Pres_nat = event.Pres_nat
        //       this.current_id = event.Pres_ID
        //       this.Pres_TpsInter = event.Pres_TpsInter
        //       Storage.remove({
        //         key: 'contact'
        //       })
        //       this.current_client = 2
        //       this.current_client_name = ''
        //       this.getContact()
        //     })
        //     .catch(e => {
        //       this.errors.push(e)
        //     })
        // }
      })
    },

    validateEnr () {
      if (this.addrdv) {
        minuAPI.post('addRDV.php', {
          'email': fb.auth.currentUser.email,
          'hdeb': this.hdeb,
          'hfin': this.hfin,
          'datedisplay': this.datedisplay,
          'Pres_nat': this.Pres_nat,
          'Pres_cl': this.current_client
        })
          .then(response => {
            // console.log(response.data) // properties
            this.loadEvents()
            this.showModalRDV = false
            Storage.remove({
              key: 'contact'
            })
            this.current_client = 2
            this.current_client_name = ''
          })
          .catch(e => {
            this.errors.push(e)
          })
      } else {
        minuAPI.post('updRDV.php', {
          'email': fb.auth.currentUser.email,
          'hdeb': this.hdeb,
          'hfin': this.hfin,
          'Pres_TpsInter': this.Pres_TpsInter,
          'datedisplay': this.datedisplay,
          'Pres_nat': this.Pres_nat,
          'Pres_ID': this.current_id
        })
          .then(response => {
            // console.log(response.data) // properties
            this.loadEvents()
            this.showModalRDV = false
          })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },

    deleteEnr () {
      if (confirm('êtes vous sur de vouloir supprimer ?')) {
        minuAPI.post('delRDV.php', {
          'email': fb.auth.currentUser.email,
          'Pres_ID': this.current_id
        })
          .then(response => {
            // console.log(response.data) // properties
            this.loadEvents()
            this.showModalRDV = false
          })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },

    loadEvents () {
      minuAPI.post('events4.php', {
        'deb': this.start.date,
        'fin': this.end.date,
        'email': fb.auth.currentUser.email
      })
        .then(response => {
          this.TC = []

          for (var key in response.data) {
            this.TC.push(key)
            this.TCnom[key] = response.data[key][0].Per_Nom + ' ' + response.data[key][0].Per_Pren
            console.log(this.TCnom[key])
          }
          console.log(this.TC) // properties
          this.events = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    getEvents ({
      start,
      end
    }) {
      this.start = start
      this.end = end
      // console.log(this.events)
      console.log(start.date)

      this.loadEvents()

      minuAPI.post('events2.php', {
        'deb': start.date,
        'fin': end.date,
        'Pres_nat': 13,
        'email': fb.auth.currentUser.email
      })
        .then(response => {
          this.poses = response.data
          // console.log(response.data) // properties
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getWeekNumber (d) {
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
      var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7)
      return weekNo
    }
  },
  mounted () {
    this.$refs.calendar.scrollToTime('08:00')
    this.$refs.calendar.checkChange()
  },
  computed: {
    currentMonth () {
      if (this.focus) {
        const date = new Date(this.focus)
        const month = date.toLocaleString('fr-FR', { month: 'long' }).toUpperCase()
        const week = this.getWeekNumber(date)
        return `${month} (S. ${week})`
      }
      return ''
    }
  }
}

</script>

<style scoped>
  .col {
    padding: 0px;
  }

  .v-event-timed {
    border: 0px !important;
  }

  .poseList {
    padding-bottom: 100px;
  }

  .v-form {
    padding: 20px;
  }

  .addRDV {
    margin-bottom: 50px;
  }
  .toolbar-title {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/Alltcs.vue